import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntitySponsor } from "../../entity/EntitySponsor";

export class DtoSponsorsGetRes extends EntitySponsor {
  public items: EntitySponsor[]  = [];
}
